<template>
  <div class="page" :class="{ embedded }">
    <div class="card">
      <div class="tabs-bar">
        <div class="tabs">
          <button class="tab" :class="{ active: tab === 'summary' }" type="button" @click="tab = 'summary'">Resumo</button>
          <button class="tab" :class="{ active: tab === 'gantt' }" type="button" @click="tab = 'gantt'">Planejamento</button>
          <button class="tab" :class="{ active: tab === 'reports' }" type="button" @click="tab = 'reports'">Relatórios</button>
          <button class="tab" :class="{ active: tab === 'files' }" type="button" @click="tab = 'files'">Arquivos</button>
          <button class="tab" :class="{ active: tab === 'attendance' }" type="button" @click="tab = 'attendance'">Presenças</button>
          <!--<button class="tab" :class="{ active: tab === 'warehouse' }" type="button" @click="tab = 'warehouse'">Almoxarifado</button>-->
          <button class="tab" :class="{ active: tab === 'teams' }" type="button" @click="tab = 'teams'">Equipes</button>
          <button class="tab" :class="{ active: tab === 'pendencias' }" type="button" @click="tab = 'pendencias'">Pendências</button>
          <!--<button class="tab" :class="{ active: tab === 'tickets' }" type="button" @click="tab = 'tickets'">Chamados</button>-->
        </div>
        <div class="tabs-actions" id="gantt-toolbar-slot"></div>
      </div>

      <div class="tab-body" :class="{ 'tab-body--gantt': tab === 'gantt' }">
        <!-- Resumo tab -->
        <ProjectSummarySection
          v-if="tab === 'summary'"
          :loading="initialLoading"
          :project-name="projectName"
          :progress="summaryProgress"
          :gantt-rows="ganttRows"
          :project-reports="projectReports"
          :project-reservations="projectReservations"
          :project-tickets="projectTickets"
          :assignable-users="assignableUsers"
          :warehouse-items="warehouseItems"
          @navigate="tab = $event"
        />

        <ProjectFilesSection v-else-if="tab === 'files'" :project-id="resolvedProjectId" :access-mode="accessMode" />
        <template v-else-if="tab === 'reports'">
          <div v-if="reportSubview !== 'list'" class="report-back-bar">
            <button class="report-back-btn" type="button" @click="closeReportSubview">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
              Voltar à lista
            </button>
          </div>
          <ProjectReportsSection
            v-if="reportSubview === 'list'"
            :loading="initialLoading"
            :items="projectReports"
            :access-mode="accessMode"
            @view-report="openReportView"
            @edit-report="openReportEdit"
            @delete-reports="deleteProjectReports"
          />
          <SubmissionView
            v-else-if="reportSubview === 'view' && activeReportItem?.category === 'relatorio'"
            :embedded="true"
            :submission-id="activeReportId"
            @back="closeReportSubview"
            @edit="openReportEdit"
          />
          <SafetyDocumentView
            v-else-if="reportSubview === 'view' && activeReportItem"
            :embedded="true"
            :submission-id="activeReportId"
            @back="closeReportSubview"
            @edit="openReportEdit"
          />
          <SubmissionFormView
            v-else-if="reportSubview === 'edit' && activeReportItem?.category === 'relatorio'"
            :embedded="true"
            :submission-id="activeReportId"
            @done="closeReportSubviewAndRefresh"
            @cancel="closeReportSubview"
          />
          <SafetyDialogFormView
            v-else-if="reportSubview === 'edit' && activeReportItem?.category === 'dialogo'"
            :embedded="true"
            :submission-id="activeReportId"
            @done="closeReportSubviewAndRefresh"
            @cancel="closeReportSubview"
          />
          <SafetyOccurrenceFormView
            v-else-if="reportSubview === 'edit' && activeReportItem?.category === 'ocorrido'"
            :embedded="true"
            :submission-id="activeReportId"
            @done="closeReportSubviewAndRefresh"
            @cancel="closeReportSubview"
          />
          <SafetyDocumentView
            v-else-if="reportSubview === 'edit' && activeReportItem"
            :embedded="true"
            :submission-id="activeReportId"
            @back="closeReportSubview"
            @edit="closeReportSubview"
          />
        </template>

        <ProjectGanttSection
          v-else-if="tab === 'gantt'"
          :loading="initialLoading"
          :rows="ganttRows"
          :tasks="tasks"
          :assignee-name="assigneeName"
          :assignable-users="assignableUsers"
          :warehouse-items="warehouseItems"
          :access-mode="accessMode"
          :blocked-dates="blockedDates"
          :project-id="resolvedProjectId"
          :on-save-task="saveTaskById"
          :on-import-tasks="importTasks"
          :on-update-progress="updateProgress"
          :on-save-blocked-dates="saveBlockedDates"
          :on-delete-task="deleteTask"
          :on-delete-progress="deleteProgressUpdate"
          :project-name="projectName"
          :system-name="systemName"
          :logo-text="logoText"
          :is-analyst="isAnalyst"
          :open-new-task="openNewTaskFlag"
          :groups="taskGroups"
          :on-save-group="saveGroup"
          :on-delete-group="deleteGroup"
        />

        <ProjectPendenciasSection
          v-else-if="tab === 'pendencias'"
          :project-id="resolvedProjectId"
          :project-name="projectName"
          :access-mode="accessMode"
          :tasks="ganttRows"
          :open-create="pendenciasOpenCreate"
        />

        <ProjectAttendanceSection
          v-else-if="tab === 'attendance'"
          :project-id="resolvedProjectId"
          :access-mode="accessMode"
        />

        <ProjectWarehouseSection
          v-else-if="tab === 'warehouse'"
          :reservations="projectReservations"
          :item-name="itemName"
        />

        <ProjectTeamsSection
          v-else-if="tab === 'teams'"
          :project-id="resolvedProjectId"
          :access-mode="accessMode"
          :all-users="assignableUsers"
        />

        <ProjectTicketsSection
          v-else
          :show-form="showTicketForm"
          :form="ticketForm"
          :items="projectTickets"
          :ticket-approval-status="ticketApprovalStatus"
          :on-toggle-form="toggleTicketForm"
          :on-create="createTicket"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { apiFetch } from '@/store/api'
import { sessionStore } from '@/store/session'
import { uiStore } from '@/store/ui'
import SubmissionView from '@/views/SubmissionView.vue'
import SubmissionFormView from '@/views/SubmissionFormView.vue'
import SafetyDocumentView from '@/views/SafetyDocumentView.vue'
import SafetyDialogFormView from '@/views/SafetyDialogFormView.vue'
import SafetyOccurrenceFormView from '@/views/SafetyOccurrenceFormView.vue'
import ProjectFilesSection from '@/components/project-workspace/ProjectFilesSection.vue'
import ProjectGanttSection from '@/components/project-workspace/ProjectGanttSection.vue'
import ProjectAttendanceSection from '@/components/project-workspace/ProjectAttendanceSection.vue'
import ProjectWarehouseSection from '@/components/project-workspace/ProjectWarehouseSection.vue'
import ProjectTeamsSection from '@/components/project-workspace/ProjectTeamsSection.vue'
import ProjectTicketsSection from '@/components/project-workspace/ProjectTicketsSection.vue'
import ProjectReportsSection from '@/components/project-workspace/ProjectReportsSection.vue'
import ProjectSummarySection from '@/components/project-workspace/ProjectSummarySection.vue'
import ProjectPendenciasSection from '@/components/project-workspace/ProjectPendenciasSection.vue'
import { formatDateOnly } from '@/utils/date'
import type { Submission } from '@/store/submissions'

interface ProjectTask {
  id: string
  title: string
  description?: string
  color?: string
  assigneeUsername: string
  plannedStart: string
  plannedEnd: string
  dependencyTaskIds: string[]
  requiredTools?: Array<{ itemId: string; quantity: number }>
  requiredMachinery?: Array<{ machineryId: string; quantity: number }>
  infraestruturaNecessaria?: string
  linkedFileIds?: string[]
  teamIds?: string[]
  progressUpdates?: Array<{ id?: string; progressDate: string; notes?: string; progressPercent?: number }>
}

interface ProjectRow {
  id: string
  name: string
}

function slugifyProjectName(value: string) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export default defineComponent({
  name: 'ProjectWorkspaceView',
  components: {
    SubmissionView,
    SubmissionFormView,
    SafetyDocumentView,
    SafetyDialogFormView,
    SafetyOccurrenceFormView,
    ProjectFilesSection,
    ProjectGanttSection,
    ProjectAttendanceSection,
    ProjectWarehouseSection,
    ProjectTeamsSection,
    ProjectTicketsSection,
    ProjectReportsSection,
    ProjectSummarySection,
    ProjectPendenciasSection
  },
  props: {
    embedded: { type: Boolean, default: false },
    projectId: { type: String, default: '' },
    isAnalyst: { type: Boolean, default: false },
    systemName: { type: String, default: '' },
    logoText: { type: String, default: 'ObraTycoon by GusMachado' }
  },
  setup(props) {
    const route = useRoute()
    const router = useRouter()

    type TabKey = 'summary' | 'files' | 'reports' | 'gantt' | 'attendance' | 'warehouse' | 'teams' | 'tickets' | 'pendencias'

    const TAB_TO_SLUG: Record<TabKey, string> = {
      summary: 'resumo',
      gantt: 'planejamento',
      reports: 'relatorios',
      files: 'arquivos',
      attendance: 'presencas',
      teams: 'equipes',
      pendencias: 'pendencias',
      warehouse: 'almoxarifado',
      tickets: 'chamados'
    }
    const SLUG_TO_TAB: Record<string, TabKey> = Object.fromEntries(
      Object.entries(TAB_TO_SLUG).map(([k, v]) => [v, k as TabKey])
    )

    const tabFromRoute = (): TabKey => {
      const slug = String(route.params.workspaceTab || '').toLowerCase()
      return SLUG_TO_TAB[slug] || 'summary'
    }

    const tab = ref<TabKey>(tabFromRoute())
    const openNewTaskFlag = ref(false)
    const pendenciasOpenCreate = ref(false)

    const resolvedProjectId = ref('')
    const initialLoading = ref(true)
    const projectName = ref('')
    const accessMode = ref<'read' | 'edit'>('read')
    const tasks = ref<ProjectTask[]>([])
    const ganttRows = ref<ProjectTask[]>([])
    const blockedDates = ref<string[]>([])
    const taskGroups = ref<Array<{ id: string; name: string; responsibleUsername: string; color: string }>>([])

    const warehouseItems = ref<Array<{ id: string; name: string; availableQuantity: number }>>([])
    const projectReservations = ref<Array<{ id: string; itemId: string; taskId: string; quantity: number; reserveStartDate: string; reserveEndDate: string }>>([])
    const projectTickets = ref<Array<{ id: string; title: string; category: string; priority: string; status: string }>>([])
    const projectReports = ref<Submission[]>([])
    const assignableUsers = ref<Array<{ username: string; name: string }>>([])
    const showTaskForm = ref(false)
    const taskFormError = ref('')
    const editingTaskId = ref('')
    const expandedTaskId = ref('')
    const showTicketForm = ref(false)
    const reportSubview = ref<'list' | 'view' | 'edit'>('list')
    const activeReportId = ref('')
    const weekdays = [
      { value: 'mon', label: 'seg' },
      { value: 'tue', label: 'ter' },
      { value: 'wed', label: 'qua' },
      { value: 'thu', label: 'qui' },
      { value: 'fri', label: 'sex' },
      { value: 'sat', label: 'sab' },
      { value: 'sun', label: 'dom' }
    ]

    const taskForm = ref({
      title: '',
      description: '',
      durationDays: 1,
      workDays: ['mon', 'tue', 'wed', 'thu', 'fri'],
      dependencyTaskIds: [] as string[],
      requiredTools: [] as Array<{ itemId: string; quantity: number }>,
      requiredMachinery: [] as Array<{ machineryId: string; quantity: number }>,
      forcedStartDate: '',
      assigneeUsername: '',
      color: '#2f6fce',
      infraestruturaNecessaria: '',
      linkedFileIds: [] as string[],
      teamIds: [] as string[]
    })

    const ticketForm = ref({
      title: '',
      category: 'problema-projeto',
      priority: 'media',
      description: '',
      location: ''
    })

    const activeReportItem = computed(() =>
      projectReports.value.find((entry) => entry.id === activeReportId.value) || null
    )

    const resolveProjectId = async () => {
      if (props.projectId) {
        resolvedProjectId.value = props.projectId
        return
      }
      const routeId = String(route.params.id || '').trim()
      if (routeId) {
        resolvedProjectId.value = routeId
        return
      }
      const routeSlug = String(route.params.projectSlug || '').trim().toLowerCase()
      if (!routeSlug) {
        resolvedProjectId.value = ''
        return
      }
      const rows = await apiFetch<ProjectRow[]>('/projects')
      const found = rows.find((item) => slugifyProjectName(item.name) === routeSlug)
      resolvedProjectId.value = found?.id || ''
    }

    const refreshDashboard = async () => {
      if (!resolvedProjectId.value) return
      const row = await apiFetch<{ name: string; accessMode: 'read' | 'edit' }>(`/projects/${encodeURIComponent(resolvedProjectId.value)}/dashboard`)
      projectName.value = row.name
      accessMode.value = row.accessMode
    }

    const refreshTasks = async () => {
      if (!resolvedProjectId.value) return
      tasks.value = await apiFetch<ProjectTask[]>(`/projects/${encodeURIComponent(resolvedProjectId.value)}/tasks`)
    }
    const refreshGantt = async () => {
      if (!resolvedProjectId.value) return
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const result = await apiFetch<any>(`/projects/${encodeURIComponent(resolvedProjectId.value)}/gantt`)
      // Handle both old format (array) and new format ({ tasks, blockedDates, groups })
      if (Array.isArray(result)) {
        ganttRows.value = result
        blockedDates.value = []
        taskGroups.value = []
      } else {
        ganttRows.value = result.tasks || []
        blockedDates.value = result.blockedDates || []
        taskGroups.value = result.groups || []
      }
    }

    const saveTaskById = async (taskId: string, form: {
      title: string; description: string; durationDays: number; workDays: string[];
      dependencyTaskIds: string[]; requiredTools: Array<{ itemId: string; quantity: number }>;
      requiredMachinery: Array<{ machineryId: string; quantity: number }>;
      forcedStartDate: string; assigneeUsername: string; color: string; noDate?: boolean
    }) => {
      editingTaskId.value = taskId
      await saveTask(form)
      await refreshGantt()
      editingTaskId.value = ''
    }

    const saveGroup = async (payload: { name: string; responsibleUsername: string; taskIds: string[] }) => {
      if (!resolvedProjectId.value) return
      const res = await apiFetch<{ group: { id: string; name: string; responsibleUsername: string; color: string } }>(
        `/projects/${encodeURIComponent(resolvedProjectId.value)}/task-groups`,
        { method: 'POST', body: JSON.stringify(payload) }
      )
      await refreshGantt()
      return res.group
    }

    const deleteGroup = async (groupId: string) => {
      await apiFetch(`/task-groups/${encodeURIComponent(groupId)}`, { method: 'DELETE' })
      await refreshGantt()
    }

    const saveBlockedDates = async (dates: string[]) => {
      if (!resolvedProjectId.value) return
      await apiFetch(`/projects/${encodeURIComponent(resolvedProjectId.value)}/blocked-dates`, {
        method: 'POST',
        body: JSON.stringify({ dates })
      })
      blockedDates.value = dates
    }
    const refreshWarehouse = async () => {
      if (!resolvedProjectId.value) return
      warehouseItems.value = await apiFetch<Array<{ id: string; name: string; availableQuantity: number }>>('/warehouse/items')
      projectReservations.value = await apiFetch<Array<{ id: string; itemId: string; taskId: string; quantity: number; reserveStartDate: string; reserveEndDate: string }>>(
        `/warehouse/reservations?projectId=${encodeURIComponent(resolvedProjectId.value)}`
      )
    }
    const refreshTickets = async () => {
      if (!resolvedProjectId.value) return
      projectTickets.value = await apiFetch<Array<{ id: string; title: string; category: string; priority: string; status: string }>>(
        `/tickets?projectId=${encodeURIComponent(resolvedProjectId.value)}`
      )
    }
    const refreshReports = async () => {
      if (!resolvedProjectId.value || !projectName.value) return
      const rows = await apiFetch<Submission[]>('/submissions')
      projectReports.value = rows.filter((row) => row.attraction === projectName.value)
    }

    const deleteProjectReports = async (ids: string[]) => {
      for (const id of ids) {
        await apiFetch(`/submissions/${encodeURIComponent(id)}`, { method: 'DELETE' })
      }
      await refreshReports()
    }

    const closeReportSubview = () => {
      reportSubview.value = 'list'
      activeReportId.value = ''
      tab.value = 'reports'
    }

    const closeReportSubviewAndRefresh = async () => {
      await refreshReports()
      closeReportSubview()
    }

    const openReportView = (id: string) => {
      const item = projectReports.value.find((entry) => entry.id === id)
      if (!item) return
      activeReportId.value = id
      reportSubview.value = 'view'
      tab.value = 'reports'
    }

    const openReportEdit = (id: string) => {
      const item = projectReports.value.find((entry) => entry.id === id)
      if (!item) return
      activeReportId.value = id
      reportSubview.value = 'edit'
      tab.value = 'reports'
    }
    const refreshUsers = async () => {
      const rows = await apiFetch<Array<{ username: string; name: string }>>('/accounts')
      assignableUsers.value = rows.map((item) => ({
        username: String(item.username || ''),
        name: String(item.name || item.username || '')
      }))
      if (!taskForm.value.assigneeUsername) {
        const currentUsername = sessionStore.state.user?.username || ''
        const hasCurrent = assignableUsers.value.some((item) => item.username === currentUsername)
        taskForm.value.assigneeUsername = hasCurrent
          ? currentUsername
          : assignableUsers.value[0]?.username || ''
      }
    }

    const refreshAll = async () => {
      try {
        await resolveProjectId()
        if (!resolvedProjectId.value) return
        await refreshDashboard()
        await Promise.all([refreshTasks(), refreshGantt(), refreshWarehouse(), refreshTickets(), refreshReports(), refreshUsers()])
      } finally {
        initialLoading.value = false
      }
    }

    const resetTaskForm = () => {
      const currentUsername = sessionStore.state.user?.username || ''
      const hasCurrent = assignableUsers.value.some((item) => item.username === currentUsername)
      taskForm.value = {
        title: '',
        description: '',
        durationDays: 1,
        workDays: ['mon', 'tue', 'wed', 'thu', 'fri'],
        dependencyTaskIds: [],
        requiredTools: [],
        requiredMachinery: [],
        forcedStartDate: '',
        assigneeUsername: hasCurrent
          ? currentUsername
          : assignableUsers.value[0]?.username || '',
        color: '#2f6fce',
        infraestruturaNecessaria: '',
        linkedFileIds: [],
        teamIds: []
      }
      editingTaskId.value = ''
      taskFormError.value = ''
    }

    const openNewTaskForm = () => {
      if (showTaskForm.value && !editingTaskId.value) {
        showTaskForm.value = false
        return
      }
      resetTaskForm()
      showTaskForm.value = true
    }

    const editTask = (taskId: string) => {
      const task = tasks.value.find((item) => item.id === taskId)
      if (!task) return
      taskForm.value = {
        title: task.title || '',
        description: task.description || '',
        durationDays: 1,
        workDays: ['mon', 'tue', 'wed', 'thu', 'fri'],
        dependencyTaskIds: [...(task.dependencyTaskIds || [])],
        requiredTools: (task.requiredTools || []).map((entry) => ({ itemId: entry.itemId, quantity: entry.quantity })),
        requiredMachinery: (task.requiredMachinery || []).map((entry) => ({ machineryId: entry.machineryId, quantity: entry.quantity })),
        forcedStartDate: task.plannedStart || '',
        assigneeUsername: task.assigneeUsername || '',
        color: task.color || '#2f6fce',
        infraestruturaNecessaria: task.infraestruturaNecessaria || '',
        linkedFileIds: task.linkedFileIds || [],
        teamIds: task.teamIds || []
      }
      taskFormError.value = ''
      editingTaskId.value = taskId
      showTaskForm.value = true
    }

    const editTaskFromGantt = (taskId: string) => {
      editTask(taskId)
    }

    const cancelTaskForm = () => {
      resetTaskForm()
      showTaskForm.value = false
    }

    const toggleTaskDetails = (taskId: string) => {
      expandedTaskId.value = expandedTaskId.value === taskId ? '' : taskId
    }

    const saveTask = async (incomingForm?: {
      title: string
      description: string
      durationDays: number
      workDays: string[]
      dependencyTaskIds: string[]
      requiredTools: Array<{ itemId: string; quantity: number }>
      requiredMachinery: Array<{ machineryId: string; quantity: number }>
      forcedStartDate: string
      assigneeUsername: string
      color: string
      infraestruturaNecessaria?: string
      linkedFileIds?: string[]
      teamIds?: string[]
      noDate?: boolean
    }) => {
      if (!resolvedProjectId.value) return
      const formData = incomingForm || taskForm.value
      const safeFormData = {
        ...formData,
        dependencyTaskIds: [...(formData.dependencyTaskIds || [])],
        requiredTools: (formData.requiredTools || []).map((entry) => ({ itemId: entry.itemId, quantity: Number(entry.quantity || 1) })),
        requiredMachinery: (formData.requiredMachinery || []).map((entry) => ({ machineryId: entry.machineryId, quantity: Number(entry.quantity || 1) })),
        color: `${formData.color || '#2f6fce'}`.trim() || '#2f6fce',
        infraestruturaNecessaria: formData.infraestruturaNecessaria || '',
        linkedFileIds: [...(formData.linkedFileIds || [])],
        teamIds: [...(formData.teamIds || [])]
      }
      taskForm.value = safeFormData
      taskFormError.value = ''
      if (!`${safeFormData.title || ''}`.trim()) {
        taskFormError.value = 'Titulo da tarefa e obrigatorio.'
        return
      }
      if (!`${safeFormData.assigneeUsername || ''}`.trim()) {
        taskFormError.value = 'Selecione um responsavel para a tarefa.'
        return
      }
      try {
        await apiFetch(`/projects/${encodeURIComponent(resolvedProjectId.value)}/tasks`, {
          method: 'POST',
          body: JSON.stringify({
            id: editingTaskId.value || undefined,
            ...safeFormData
          })
        })
        await Promise.all([refreshTasks(), refreshGantt(), refreshWarehouse()])
        cancelTaskForm()
      } catch (err: unknown) {
        taskFormError.value = err instanceof Error ? err.message : 'Falha ao salvar tarefa.'
      }
    }

    const normalizeTaskPayload = (formData: {
      title: string
      description: string
      durationDays: number
      workDays: string[]
      dependencyTaskIds: string[]
      requiredTools: Array<{ itemId: string; quantity: number }>
      requiredMachinery: Array<{ machineryId: string; quantity: number }>
      forcedStartDate: string
      assigneeUsername: string
      color: string
      infraestruturaNecessaria?: string
      linkedFileIds?: string[]
      teamIds?: string[]
    }) => ({
      ...formData,
      dependencyTaskIds: [...(formData.dependencyTaskIds || [])],
      requiredTools: (formData.requiredTools || []).map((entry) => ({ itemId: entry.itemId, quantity: Number(entry.quantity || 1) })),
      requiredMachinery: (formData.requiredMachinery || []).map((entry) => ({ machineryId: entry.machineryId, quantity: Number(entry.quantity || 1) })),
      color: `${formData.color || '#2f6fce'}`.trim() || '#2f6fce',
      infraestruturaNecessaria: formData.infraestruturaNecessaria || '',
      linkedFileIds: [...(formData.linkedFileIds || [])],
      teamIds: [...(formData.teamIds || [])]
    })

    const importTasks = async (forms: Array<{
      title: string
      description: string
      durationDays: number
      workDays: string[]
      dependencyTaskIds: string[]
      requiredTools: Array<{ itemId: string; quantity: number }>
      requiredMachinery: Array<{ machineryId: string; quantity: number }>
      forcedStartDate: string
      assigneeUsername: string
      color: string
      infraestruturaNecessaria?: string
      linkedFileIds?: string[]
      teamIds?: string[]
    }>) => {
      if (!resolvedProjectId.value) return
      for (const form of forms) {
        const safeFormData = normalizeTaskPayload(form)
        await apiFetch(`/projects/${encodeURIComponent(resolvedProjectId.value)}/tasks`, {
          method: 'POST',
          body: JSON.stringify(safeFormData)
        })
      }
      await Promise.all([refreshTasks(), refreshGantt(), refreshWarehouse()])
    }

    const deleteTask = async (taskId: string) => {
      if (!await uiStore.confirm('Deseja apagar esta tarefa?')) return
      await apiFetch(`/tasks/${encodeURIComponent(taskId)}`, { method: 'DELETE' })
      await Promise.all([refreshTasks(), refreshGantt(), refreshWarehouse()])
      if (editingTaskId.value === taskId) cancelTaskForm()
    }

    const updateProgress = async (taskId: string, payload?: { progressPercent?: number; notes?: string; progressDate?: string; photo?: string }) => {
      await apiFetch(`/tasks/${encodeURIComponent(taskId)}/progress`, {
        method: 'POST',
        body: JSON.stringify({
          progressPercent: Number(payload?.progressPercent || 0),
          notes: `${payload?.notes || ''}`.trim(),
          progressDate: `${payload?.progressDate || ''}`.trim(),
          photo: payload?.photo || undefined
        })
      })
      await Promise.all([refreshTasks(), refreshGantt()])
    }

    const deleteProgressUpdate = async (taskId: string, updateId: string) => {
      await apiFetch(`/tasks/${encodeURIComponent(taskId)}/progress-update/${encodeURIComponent(updateId)}`, {
        method: 'DELETE'
      })
      await Promise.all([refreshTasks(), refreshGantt()])
    }

    const toggleTicketForm = () => {
      showTicketForm.value = !showTicketForm.value
    }

    const createTicket = async (incomingForm?: {
      title: string
      category: string
      priority: string
      description: string
      location: string
    }) => {
      if (!resolvedProjectId.value) return
      const nextForm = incomingForm || ticketForm.value
      await apiFetch('/tickets', {
        method: 'POST',
        body: JSON.stringify({
          title: nextForm.title,
          category: nextForm.category,
          priority: nextForm.priority,
          description: nextForm.description,
          location: nextForm.location,
          projectId: resolvedProjectId.value
        })
      })
      ticketForm.value = {
        title: '',
        category: 'problema-projeto',
        priority: 'media',
        description: '',
        location: ''
      }
      showTicketForm.value = false
      await refreshTickets()
    }

    const dependencyNames = (task: ProjectTask) =>
      task.dependencyTaskIds.map((id) => tasks.value.find((entry) => entry.id === id)?.title || id)
    const itemName = (itemId: string) => warehouseItems.value.find((item) => item.id === itemId)?.name || itemId
    const assigneeName = (username: string) => assignableUsers.value.find((item) => item.username === username)?.name || username
    const ticketApprovalStatus = (status: string) => {
      if (status === 'resolvido' || status === 'em-andamento') return 'aprovado'
      return 'aguardando aprovacao'
    }

    const summaryProgress = computed(() => {
      const rows = ganttRows.value
      if (!rows.length) return 0
      let total = 0
      for (const task of rows) {
        const updates = task.progressUpdates || []
        const last = updates[updates.length - 1]
        total += last?.progressPercent ?? 0
      }
      return Math.round(total / rows.length)
    })

    watch(
      () => [props.projectId, route.params.projectSlug],
      () => {
        refreshAll().catch(() => {
          // ignore refresh errors
        })
      }
    )

    // Sync tab → URL
    watch(tab, (nextTab: TabKey) => {
      if (nextTab !== 'reports' && reportSubview.value !== 'list') {
        reportSubview.value = 'list'
        activeReportId.value = ''
      }
      const systemUsername = String(route.params.systemUsername || '')
      const projectSlug = String(route.params.projectSlug || '')
      if (!systemUsername || !projectSlug) return
      const targetSlug = TAB_TO_SLUG[nextTab]
      const currentSlug = String(route.params.workspaceTab || '')
      if (targetSlug !== currentSlug) {
        router.replace(`/${encodeURIComponent(systemUsername)}/projeto/${encodeURIComponent(projectSlug)}/${targetSlug}`)
      }
    })

    // Sync URL → tab (browser back/forward)
    watch(
      () => route.params.workspaceTab,
      () => {
        const fromRoute = tabFromRoute()
        if (tab.value !== fromRoute) tab.value = fromRoute
      }
    )

    onMounted(() => {
      refreshAll().catch(() => {
        // keep page interactive even when one API fails
      })
      if (route.query.newTask === '1') {
        tab.value = 'gantt'
        openNewTaskFlag.value = true
      }
      if (route.query.pendencias === '1') {
        tab.value = 'pendencias'
        pendenciasOpenCreate.value = true
      }
    })

    return {
      tab,
      resolvedProjectId,
      initialLoading,
      projectName,
      accessMode,
      tasks,
      ganttRows,
      warehouseItems,
      projectReservations,
      projectTickets,
      projectReports,
      reportSubview,
      activeReportId,
      activeReportItem,
      assignableUsers,
      showTaskForm,
      taskForm,
      taskFormError,
      editingTaskId,
      expandedTaskId,
      weekdays,
      ticketForm,
      showTicketForm,
      openNewTaskForm,
      saveTask,
      cancelTaskForm,
      toggleTaskDetails,
      editTask,
      editTaskFromGantt,
      deleteTask,
      updateProgress,
      deleteProgressUpdate,
      toggleTicketForm,
      createTicket,
      closeReportSubview,
      closeReportSubviewAndRefresh,
      blockedDates,
      saveTaskById,
      importTasks,
      saveBlockedDates,
      dependencyNames,
      itemName,
      assigneeName,
      ticketApprovalStatus,
      formatReportDate: formatDateOnly,
      openReportView,
      openReportEdit,
      deleteProjectReports,
      summaryProgress,
      openNewTaskFlag,
      pendenciasOpenCreate,
      taskGroups,
      saveGroup,
      deleteGroup
    }
  }
})
</script>

<style scoped lang="scss">
.page.embedded {
  min-height: auto;
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.page.embedded .card {
  box-shadow: none;
  border-radius: 0;
  padding: 0;
  background: transparent;
  width: 100%;
  max-width: none;
  margin: 0;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.report-back-bar {
  padding: 10px 16px 0;
  flex-shrink: 0;
}

.report-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 14px;
  border-radius: 8px;
  border: 1px solid var(--accent, #0f4c81);
  background: transparent;
  color: var(--accent, #0f4c81);
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: var(--accent, #0f4c81);
    color: #fff;
  }
}

.tabs-bar {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  border-bottom: 2px solid rgba(31, 30, 26, 0.1);
  flex-shrink: 0;
  gap: 0;
  min-height: 48px;
}

.tabs {
  display: flex;
  align-items: stretch;
  overflow-x: auto;
  scrollbar-width: none;
  height: 100%;
}

.tabs::-webkit-scrollbar { display: none; }

.tabs-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  flex-shrink: 0;
}

@media (max-width: 640px) {
  .tabs-bar {
    flex-wrap: wrap;
    height: auto;
  }
  .tabs {
    flex: 1 1 100%;
    min-width: 0;
    height: auto;
  }
  .tab {
    height: 44px;
    padding: 0 14px;
  }
  .tabs-actions {
    flex: 1 1 100%;
    min-height: 44px;
    overflow-x: auto;
    scrollbar-width: none;
    padding: 6px 8px;
    border-top: 1px solid rgba(31, 30, 26, 0.08);
  }
  .tabs-actions::-webkit-scrollbar { display: none; }
  .tabs-actions:empty {
    display: none;
  }
}

.tab {
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  padding: 12px 16px;
  cursor: pointer;
  font-weight: 500;
  font-size: 13px;
  color: var(--ink-muted, #605e5c);
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;
  margin-bottom: -2px;
  display: flex;
  align-items: center;
  height: 100%;
}

.tab:hover {
  color: var(--ink, #201f1e);
}

.tab.active {
  color: var(--system-navbar, #4f3300);
  border-bottom-color: var(--system-navbar, #4f3300);
  font-weight: 700;
}

.tab-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.tab-body--gantt {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}



.panel-close {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--ink-muted);
  font-size: 16px;
  padding: 4px 6px;
  line-height: 1;
  border-radius: var(--radius-sm);
}

.panel-close:hover {
  background: var(--surface-3);
}

</style>
